import BaseTitle from './BaseTitle'
export default BaseTitle
